import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaInstagram, FaTruck, FaTwitch, FaVk, FaYoutube } from 'react-icons/fa';
import Logo from '../assets/img/logo.svg';

const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  const socialLinks = [
    { href: 'https://truckersmp.com/vtc/48336-mileageriot', label: t('footer.socialLinks.tmp'), icon: FaTruck, className: 'is-tmp' },
    { href: 'https://vk.com/mileageriot', label: t('footer.socialLinks.vk'), icon: FaVk, className: 'is-vk' },
    { href: 'https://www.youtube.com/@mileageriot_official', label: t('footer.socialLinks.youtube'), icon: FaYoutube, className: 'is-youtube' },
    { href: 'https://twitch.tv/mileageriot_official', label: t('footer.socialLinks.twitch'), icon: FaTwitch, className: 'is-twitch' },
    { href: 'https://www.instagram.com/mileageriot_official/', label: t('footer.socialLinks.instagram'), icon: FaInstagram, className: 'is-instagram' },
  ];

  return (
    <footer className="site-footer-upgraded">
      <div className="footer-grid-background" aria-hidden="true"></div>
      <div className="container footer-container">
        <div className="footer-main-grid">
          <div className="footer-brand">
            <Link to="/" className="footer-logo" aria-label="Mileage Riot">
              <img src={Logo} alt="" />
            </Link>
            <p>{t('footer.mission')}</p>
            <span className="footer-brand-tag"><i aria-hidden="true"></i>{t('footer.verifiedVtc')}</span>
          </div>

          <nav className="footer-navigation" aria-label={t('footer.navigation')}>
            <h2>{t('footer.navigation')}</h2>
            <div className="footer-link-grid">
              <Link to="/">{t('nav.home')}</Link>
              <Link to="/news">{t('nav.news')}</Link>
              <Link to="/events">{t('nav.convoys')}</Link>
              <Link to="/staff">{t('nav.team')}</Link>
              <Link to="/support">{t('nav.support')}</Link>
              <a href="/#partners">{t('nav.partners')}</a>
            </div>
          </nav>

          <div className="footer-community">
            <h2>{t('footer.community')}</h2>
            <p>{t('footer.communityHint')}</p>
            <div className="footer-social-links">
              {socialLinks.map(({ href, label, icon: Icon, className }) => (
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={className}
                  aria-label={label}
                  title={label}
                  key={href}
                >
                  <Icon aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>{t('footer.copyright', { year })}</p>
          <Link to="/privacy">{t('footer.termsAndPrivacy')}</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
